<template>
  <div class="date-range-component">
    <date-picker v-model="dateRange"
                 mode="range"
                 :popover="{placement: 'bottom', visibility: 'click'}"
                 :attributes="datePickerAttrs"
                 :max-date="new Date()"
                 ref="datePicker"
                 @popoverDidShow="handleCalendarShow"
                 @popoverWillHide="handleCalendarHide"
                 @input="handleDatePickerInput">

      <b-form-input :placeholder="$t('dateRangePicker.selectDateRange')" :value="dateRangeText" readonly class="inp"></b-form-input>
    </date-picker>
    <i v-if="dateRange" class="icon icon--close" @click="handleClear"></i>
  </div>
</template>

<script>
  import Vue from "vue";
  import moment from "moment";
  import DatePicker from 'v-calendar/lib/components/date-picker.umd'

  import DataRangePickerShortcuts from './DateRangePickerShortcuts';

  export default {
    name: 'date-range-picker',
    props: {
      value: {
        type: [Object],
        default: null
      }
    },
    components: {
      DatePicker
    },
    data() {
      return {
        dateRange: null,
        datePickerAttrs: [
          {
            key: 'today',
            dot: true,
            dates: new Date(),
          },
        ],
        shortcutsInstance: null
      }
    },

    created() {
      this.dateRange = this.value;
    },

    beforeDestroy() {
      if (this.shortcutsInstance) {
        this.shortcutsInstance.$destroy();
        this.shortcutsInstance.$el.remove();
      }
    },

    computed: {
      dateRangeText() {
        return this.dateRange ? moment(this.dateRange.start).format('ll') + ' - ' + moment(this.dateRange.end).format('ll') : '';
      }
    },

    watch: {
      value: function(val) {
        this.dateRange = val;
        if (this.shortcutsInstance) {
          this.shortcutsInstance.clearShortcut();
        }
      }
    },

    methods: {
      handleCalendarShow() {
        const popoverEl = this.$el.querySelector('div.vc-popover-content-wrapper');
        let shortcutsContainerElement = popoverEl.querySelector('#date-range-picker-shortcuts');
        if (!shortcutsContainerElement) {
          shortcutsContainerElement = document.createElement('DIV');
          shortcutsContainerElement.setAttribute('id', 'date-range-picker-shortcuts');
          popoverEl.appendChild(shortcutsContainerElement);
        }

        if (!this.shortcutsInstance) {
          const shortcutsComponent = Vue.extend(DataRangePickerShortcuts);
          this.shortcutsInstance = new shortcutsComponent();
          this.shortcutsInstance.$on('changeDateRange', this.handleChangeShortcutDateRange);
          this.shortcutsInstance.$mount(shortcutsContainerElement);
        }
        this.shortcutsInstance.showShortcuts();
      },

      handleCalendarHide() {
        if (this.shortcutsInstance) {
          this.shortcutsInstance.hideShortcuts();
        }
      },

      handleDatePickerInput(value) {
        this.shortcutsInstance.clearShortcut();
        this.$emit('input', value);
      },

      handleChangeShortcutDateRange(value) {
        this.$refs['datePicker'].hidePopover();
        this.dateRange = value;
        this.$emit('input', value);
      },

      handleClear() {
        this.shortcutsInstance.handleDPClear();
      }
    },
  }
</script>
<style lang="scss" scoped>
  .icon--close{
    position: absolute;
    margin-left: -27px;
    cursor: pointer;
    &:before, &:after {
      background: #a2a2a2 !important;
    }
  }

</style>
